var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,0C8.286,0,2,.737,2,3.5c0,.017.007.033.007.05h-.007v16.95c0,2.763,6.286,3.5,10,3.5,3.459,0,10-.742,10-3.55V3.5c0-2.763-6.286-3.5-10-3.5Zm8,7.368c-.398.585-3.413,1.632-8,1.632s-7.597-1.017-8-1.585v-1.68c2.159.955,5.609,1.264,8,1.264s5.841-.31,8-1.265v1.633Zm0,9c-.398.585-3.413,1.632-8,1.632s-7.597-1.017-8-1.585v-6.68c2.159.955,5.609,1.264,8,1.264,2.248,0,5.79-.318,8-1.309v6.677ZM12,2c4.746,0,7.396.986,7.937,1.5-.542.514-3.191,1.5-7.937,1.5s-7.396-.986-7.937-1.5c.541-.514,3.191-1.5,7.937-1.5Zm0,20c-4.562,0-7.574-1.007-8-1.577v-1.687c2.159.955,5.609,1.264,8,1.264,2.248,0,5.79-.318,8-1.309v1.685c-.422.586-3.436,1.624-8,1.624Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/Database.ac641c323d97439432c422cd3dc83871.svg";
export { ForwardRef as ReactComponent };